import { isSameDay, isSameHour, addDays, addHours } from 'date-fns'

import type { DateFilterOption } from '@/components/DateFilters'

export type TimeInterval = 'hour' | 'day'

export const getTimeInterval = (selectedDateFilter: DateFilterOption): TimeInterval =>
  selectedDateFilter === 'today' ? 'hour' : 'day'

type RecursiveGetDatesBetweenRangeArgs = {
  ascendingDates: Date[]
  endDate: Date
  timeInterval: TimeInterval
}

const recursiveGetDatesBetweenRange = ({
  ascendingDates,
  endDate,
  timeInterval,
}: RecursiveGetDatesBetweenRangeArgs): Date[] => {
  const ascendingDatesTail = [...ascendingDates].pop()

  if (ascendingDatesTail === undefined) {
    return []
  }

  if (timeInterval === 'hour' && isSameHour(ascendingDatesTail, endDate)) {
    return ascendingDates
  }

  if (timeInterval === 'day' && isSameDay(ascendingDatesTail, endDate)) {
    return ascendingDates
  }

  return recursiveGetDatesBetweenRange({
    ascendingDates: [
      ...ascendingDates,
      timeInterval === 'hour'
        ? addHours(ascendingDatesTail, 1)
        : addDays(ascendingDatesTail, 1),
    ],
    endDate,
    timeInterval,
  })
}

type GetDatesBetweenRangeArgs = {
  startDate: Date
  endDate: Date
  timeInterval: TimeInterval
}

export const getDatesBetweenRange = ({
  startDate,
  endDate,
  timeInterval,
}: GetDatesBetweenRangeArgs): Date[] =>
  recursiveGetDatesBetweenRange({ ascendingDates: [startDate], endDate, timeInterval })
